import { ReactNode } from 'react';
import { localizePercentageValue } from 'utils/i18nHelpers';
import { EmptyData } from '../insightEmptyData/EmptyData';
import { InsightType } from '../../../types';
import {
  PercentageWrapper,
  PercentageSkeleton,
  PercentageInsightPanel as PercentageInsightPanelWrapper,
} from './BehaviorInsights.styled';

export type PercentageInsightPanelProps = {
  title: string;
  children?: ReactNode;
  percentage?: number;
  showSelect?: boolean;
  isLoading?: boolean;
  isEmpty?: boolean;
};

export const PercentageInsightPanel = ({
  children,
  title,
  showSelect,
  percentage = 0,
  isLoading = false,
  isEmpty = false,
}: PercentageInsightPanelProps) => {
  const localizedPercentageValue = localizePercentageValue(percentage, false);

  const getPanelContent = () => {
    if (isEmpty) {
      return <EmptyData type={InsightType.behavioral} />;
    }
    if (isLoading) {
      return <PercentageSkeleton />;
    } else {
      return (
        <>
          <PercentageWrapper>{localizedPercentageValue}</PercentageWrapper>
          {children}
        </>
      );
    }
  };

  return (
    <PercentageInsightPanelWrapper title={title} showSelect={showSelect}>
      {getPanelContent()}
    </PercentageInsightPanelWrapper>
  );
};
